// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var SubscriptionListController = function ($scope, $http, $location, gettextCatalog, gettext, ProductInfo, Subscription,
    SubscriptionCounts, PaymentMethod, PaymentMethodNames, Customer,
    PaymentProviderSettings, PUtill, DunningSettings, DocumentTemplate,
    SubscriptionReport, salesEntitiesService, Features, DatepickerUtils,
    CustomFieldSettings) {
    $scope.features = Features.features;
    $scope.filter = {};
    $scope.search = '';
    $scope.showHidden = false;
    $scope.reportLocale = "de-DE";
    $scope.filterCount = 0;

    $scope.reportRequestInProgress = false;
    $scope.areSearchOptionsCollapsed = true;
    $scope.areFiltersCollapsed = false;
    $scope.areAdditionalSearchOptionsCollapsed = false;
    $scope.wasSearching = false;
    $scope.customFieldsSearchAvailable = false;
    $scope.productInfo = ProductInfo.get();

    const customFieldsMidPart = ".CustomFields.";

    $scope.salesEntities = [];
    salesEntitiesService.query({}, function (response) {
        $scope.salesEntities = response;
        let defaultEntity = response.find(function (el) {
            return el.IsDefault == true;
        });
        if (defaultEntity) {
            defaultEntity.InternalName += " (" + gettextCatalog.getString(gettext('default')) + ")";
        }
    });

    $scope.customFields = [];
    $scope.customFieldsTypes = [];
    $scope.componentSubscriptionCustomFields = [];
    $scope.componentSubscriptionCustomFieldsTypes = [];

    function fillCustomFieldsFilter(category, targetFields, targetFieldTypes) {
        return new Promise((resolve, reject) => {
            CustomFieldSettings.get({ customFieldType: category }, function (data) {
                let fields = data.CustomFieldDescriptors.filter(function (field) {
                    return field.IndexType === 'CaseInsensitive';
                });
                if (fields.length === 0) {
                    resolve();
                    return;
                }
                fields.forEach(function (field, index, array) {
                    targetFields.push({ name: field.Key, displayName: field.DisplayName._c, type: data.CustomFieldType });
                    if (!targetFieldTypes.includes(data.CustomFieldType)) {
                        targetFieldTypes.push(data.CustomFieldType);
                    }
                    if (index === array.length - 1) {
                        resolve();
                    }
                });
            }, reject); // Reject in case of an error
        });
    }

    $scope.getReport = function () {
        if ($scope.reportRequestInProgress)
            return;

        $scope.reportRequestInProgress = true;

        let options = $scope.filter;
        options.search = $scope.search;
        options.showHidden = $scope.showHidden;
        options.Locale = $scope.reportLocale;

        options = correctDateRanges(options);

        $scope.counts = SubscriptionReport.get(options,
            function (data) {
                if (data && data.Status !== "Failed") {
                    $scope.reportRequestInProgress = false;
                    $scope.navigateToAvailableReports();
                }
            },
            function (data) {
                // response error handler
                $scope.reportRequestInProgress = true;
            });
    }

    /* filter handler */
    $scope.applyFilter = function (collapseFilters) {
        if (collapseFilters === true)
            $scope.collapseSearchOptions(true);    // use this flag to colapse the filters pane (whether or not rout gets reloaded)

        var queryParams = {};

        if ($scope.filter) {
            var filterObj = $scope.filter;

            for (var prop in filterObj) {
                if (filterObj.hasOwnProperty(prop)) {
                    // if property value not-null or undefined or empty-string
                    if (filterObj[prop]) {
                        switch (prop) {
                            case "search":
                            case "reportLocale":
                            case "showHidden":
                                break;
                            default:
                                queryParams[prop] = filterObj[prop];
                                break;
                        }
                    }
                }
            }
        }

        if ($scope.search)
            queryParams["search"] = $scope.search;

        if ($scope.showHidden)
            queryParams["showHidden"] = true;

        if ($scope.reportLocale)
            queryParams["reportLocale"] = $scope.reportLocale;

        removeDeletionMarkFilterIfInclude(queryParams);

        if (filterObj._customFields) {
            queryParams._customFields = filterObj._customFields;
            queryParams = setCustomFieldsSearch(queryParams);
            delete queryParams._customFields;
        }

        if (filterObj._customFields === "") {
            for (let key in queryParams) {
                if (key.includes("CustomFields")) {
                    delete queryParams[key];
                }
            }
        }

        if (filterObj._componentSubscriptionCustomFields) {
            queryParams._componentSubscriptionCustomFields = filterObj._componentSubscriptionCustomFields;
            queryParams = setCustomFieldsSearch(queryParams);
            delete queryParams._componentSubscriptionCustomFields;
        }

        if (filterObj._componentSubscriptionCustomFields === "") {
            for (let key in queryParams) {
                if (key.includes("CustomFields")) {
                    delete queryParams[key];
                }
            }
        }

        // Setting new url query parameter if any property changed
        // if new query parameters are present (if anything changed), this will trigger a route reload
        $location.search(queryParams);
    };

    $scope.clearFilter = function (clearSearchFieldOnly) {
        $scope.search = '';

        if (clearSearchFieldOnly !== true) {

            var filter = $scope.filter;
            for (var i in filter) {
                if (filter.hasOwnProperty(i)) {
                    filter[i] = '';
                }
            }

            $scope.filter.customersForDeletion = deletionMarkDefault;
            $scope.filter.contractsForDeletion = deletionMarkDefault;

            $scope.showHidden = false;
            $scope.iban = '';
            $scope.prepaidCardSerialNumberOrSecretCode = '';
            $scope.filter._customFields = undefined;
            $scope.filter._componentSubscriptionCustomFields = undefined;
        }

        $scope.applyFilter();
    };

    $scope.collapseSearchOptions = function (value) {
        $scope.areSearchOptionsCollapsed = value;
    }

    $scope.collapseFilters = function (value) {
        $scope.areFiltersCollapsed = value;
    }

    $scope.collapseAdditionalSearchOptions = function (value) {
        $scope.areAdditionalSearchOptionsCollapsed = value;
    }

    /* Counts */
    $scope.counts = {};
    $scope.getCustomerCounts = function () {
        var counts = $scope.counts;
        if ('AllCustomersCount' in counts) {
            if (counts.AllCustomersCount === counts.FilteredCustomersCount) {
                return counts.AllCustomersCount;
            }
            return counts.FilteredCustomersCount + " / " + counts.AllCustomersCount;
        }
        return '0';
    };
    $scope.getContractCounts = function () {
        var counts = $scope.counts;
        if ('AllContractsCount' in counts) {
            if (counts.AllContractsCount === counts.FilteredContractsCount) {
                return counts.AllContractsCount;
            }
            return counts.FilteredContractsCount + " / " + counts.AllContractsCount;
        }
        return '0';
    };
    /* load counts by filter */
    function getCounts() {
        // Disabled, because of lousy performance
        //$scope.counts = SubscriptionCounts.get(getOptions(), function () {
        //});
    }

    $scope.templates = DocumentTemplate.query({ documentType: "Dunning" });

    /* Payments */
    $scope.providers = PaymentProviderSettings.names().then(function (data) { $scope.listProviders = data; });

    // hadndlers for rowbar buttons
    $scope.deleteCustomer = function (id) {
        $scope.yesCancel(_txt('Delete customer'), _txt('Are you sure?'),
            function () {
                Customer.delete({ customerId: id }, function () {
                    reloadCurrentSubscriptionList();
                })
            });
    };

    $scope.hideCustomer = function (id) {
        $scope.yesCancel(_txt('Hide customer'), _txt('Are you sure?'),
            function () {
                changeCustomerVisibility(id, true);
            });
    };

    $scope.unhideCustomer = function (id) {
        changeCustomerVisibility(id, false);
    };

    $scope.selectionChange = function (source) {
        switch (source) {
            case "planGroup":
                $scope.filter.planId = '';
                $scope.filter.planVariantId = '';
                $scope.filter.componentId = '';
                $scope.filter.componentUsageId = '';
                $scope.filter.discountId = '';
                break;
            case "plan":
                $scope.filter.planVariantId = '';
                break;
            default:
                break;
        }
    }

    $scope.$watch("filter.contractStartFrom",
        function () {
            if ($scope.filter.contractStartFrom) {
                $scope.filter.contractStartFrom = DatepickerUtils.backToBrowserTimezone($scope.filter.contractStartFrom);

                if (!$scope.filter.contractStartTo || ($scope.filter.contractStartFrom > $scope.filter.contractStartTo)) {
                    $scope.filter.contractStartTo = new Date($scope.filter.contractStartFrom);
                    $scope.filter.contractStartTo.setDate($scope.filter.contractStartTo.getDate() + 1);
                    DatepickerUtils.markAsAlreadyInBrowserTimezone($scope.filter.contractStartTo);
                }
            } else
                $scope.filter.contractStartFrom = null;
        });

    $scope.$watch("filter.contractStartTo",
        function () {
            if ($scope.filter.contractStartTo) {
                $scope.filter.contractStartTo = DatepickerUtils.backToBrowserTimezone($scope.filter.contractStartTo);

                if ($scope.filter.contractStartFrom > $scope.filter.contractStartTo) {
                    $scope.filter.contractStartFrom = new Date($scope.filter.contractStartTo);
                    DatepickerUtils.markAsAlreadyInBrowserTimezone($scope.filter.contractStartFrom);
                }
            } else
                $scope.filter.contractStartTo = null;
        });

    $scope.$watch("filter.contractEndFrom",
        function () {
            if ($scope.filter.contractEndFrom) {
                $scope.filter.contractEndFrom = DatepickerUtils.backToBrowserTimezone($scope.filter.contractEndFrom);

                if (!$scope.filter.contractEndTo || ($scope.filter.contractEndFrom > $scope.filter.contractEndTo)) {
                    $scope.filter.contractEndTo = new Date($scope.filter.contractEndFrom);
                    $scope.filter.contractEndTo.setDate($scope.filter.contractEndTo.getDate() + 1);
                    DatepickerUtils.markAsAlreadyInBrowserTimezone($scope.filter.contractEndTo);
                }
            } else
                $scope.filter.contractEndFrom = null;
        });

    $scope.$watch("filter.contractEndTo",
        function () {
            if ($scope.filter.contractEndTo) {
                $scope.filter.contractEndTo = DatepickerUtils.backToBrowserTimezone($scope.filter.contractEndTo);

                if ($scope.filter.contractEndFrom > $scope.filter.contractEndTo) {
                    $scope.filter.contractEndFrom = new Date($scope.filter.contractEndTo);
                    DatepickerUtils.markAsAlreadyInBrowserTimezone($scope.filter.contractEndFrom);
                }
            } else
                $scope.filter.contractEndTo = null;
        });

    // check if component
    $scope.IsNonMetered = function (elem) {
        return (elem.ComponentType !== 'Metered');
    };

    $scope.navigateToAvailableReports = function () {
        $location.url("/activities/reporting-files?redirected");
    };

    function countFilters() {
        var count = 0;
        for (var i in $scope.filter) {
            if ($scope.filter.hasOwnProperty(i) && $scope.filter[i] != '' && i != 'search' && i != 'showHidden') {
                count++;
            }
        }
        $scope.filterCount = count;
    }

    function isWasSearching() {
        for (var i in $scope.filter) {
            if ($scope.filter[i]) {
                return true;
            }
        }
        return false;
    }

    function changeCustomerVisibility(id, hide) {
        $http({
            method: "POST",
            url: "/api/v1/customers/changeVisibility",
            params: { "id": id, "hidden": hide },
            data: {},
            headers: { "Content-Type": "application/json" },
            cache: false
        }).then(function () {
            reloadCurrentSubscriptionList();
        });
    }

    function _txt(msg) {
        return gettextCatalog.getString(gettext(msg));
    }

    function loadQueryParameters() {
        return new Promise((resolve) => {
            let queryParams = $location.search();

            for (let param in queryParams) {
                if (param.includes(customFieldsMidPart)) {
                    let parts = param.split('.');
                    let fieldType = parts[0];
                    const isComponentSubscriptionField = ["ComponentSubscription", "MeteredUsage", "DiscountSubscription"].includes(fieldType);

                    if (isComponentSubscriptionField) {
                        $scope.filter._componentSubscriptionCustomFields = $scope.componentSubscriptionCustomFields.filter(function (item) {
                            return item.name === parts[2] && item.type === fieldType;
                        })[0];
                        $scope.filter._componentSubscriptionCustomFields.value = queryParams[param];
                    } else {
                        $scope.filter._customFields = $scope.customFields.filter(function (item) {
                            return item.name === parts[2] && item.type === fieldType;
                        })[0];
                        $scope.filter._customFields.value = queryParams[param];
                    }
                }

                if (queryParams.hasOwnProperty(param)) {
                    // if property value is not null/undefined/empty-string
                    if (queryParams[param]) {
                        switch (param) {
                            case "search":
                            case "reportLocale":
                                $scope[param] = queryParams[param];
                                break;
                            case "showHidden":
                                $scope[param] = true;
                                break;
                            case "contractStartFrom":
                            case "contractEndFrom":
                            case "contractStartTo":
                            case "contractEndTo":
                                $scope[param] = new Date(queryParams[param]);
                                $scope.filter[param] = queryParams[param];
                                break;
                            case customFieldsMidPart:
                                break;
                            default:
                                $scope.filter[param] = queryParams[param];
                                break;
                        }
                    }
                }
            }

            // One of the signs page is not reloaded without params, but search with filters was performed
            if (queryParams.reportLocale) {
                if (!queryParams.customersForDeletion)
                    $scope.filter.customersForDeletion = $scope.deletionMark.Include;

                if (!queryParams.contractsForDeletion)
                    $scope.filter.contractsForDeletion = $scope.deletionMark.Include;
            }

            resolve();
        });
    }

    function reloadCurrentSubscriptionList() {
        var initialParams = {};
        var queryParams = $location.search();

        for (var prop in queryParams) {
            if (queryParams.hasOwnProperty(prop)) {
                // filter property values for not-null/undefined/empty-string/false
                if (queryParams[prop])
                    initialParams[prop] = queryParams[prop];
            }
        }

        getSubscriptions(initialParams);
    }

    function getSubscriptions(filterOverride) {
        let options;

        if (filterOverride == null) {
            options = angular.copy($scope.filter);
            options.search = $scope.search;
            options.showHidden = $scope.showHidden;
            removeDeletionMarkFilterIfInclude(options);
        } else
            options = filterOverride;

        options = correctDateRanges(options);
        options = setCustomFieldsSearch(options);
        let paginatorOptions = Object.assign({}, options);
        $scope.subscriptions = $scope.paginator(function (paginatorOptions, callback) {
            return Subscription.query(paginatorOptions, function () {
                callback();
                $scope.wasSearching = isWasSearching() || $scope.search !== '' || !$scope.showHidden;
            });
        }, paginatorOptions, 20);

        countFilters();
        getCounts();
    }

    function setCustomFieldsSearch(options) {
        if (options._customFields) {
            for (let prop in options) {
                if (options.hasOwnProperty(prop) && prop.includes(customFieldsMidPart))
                    delete options[prop];
            }

            if (options._customFields.name)
                options[options._customFields.type + customFieldsMidPart + options._customFields.name] = options._customFields.value ?? "";
        }

        if (options._componentSubscriptionCustomFields) {
            for (let prop in options) {
                if (
                    options.hasOwnProperty(prop) &&
                    prop.includes(customFieldsMidPart) &&
                    !prop.startsWith('Customer') && // To avoid deleting Customer custom fields in loop for component subscriptions
                    !prop.startsWith('Contract')
                ) {
                    delete options[prop];
                }
            }

            if (options._componentSubscriptionCustomFields.name)
                options[options._componentSubscriptionCustomFields.type + customFieldsMidPart + options._componentSubscriptionCustomFields.name] = options._componentSubscriptionCustomFields.value ?? "";
        }

        return options;
    }

    // ---- fix/override to include the whole Start/End -To- day
    function correctDateRanges(filterObj) {
        if (filterObj) {
            if (filterObj.contractStartTo)
                filterObj.contractStartTo.setDate(filterObj.contractStartTo.getDate() + 1);

            if (filterObj.contractEndTo)
                filterObj.contractEndTo.setDate(filterObj.contractEndTo.getDate() + 1);
        }

        return filterObj;
    }

    function removeDeletionMarkFilterIfInclude(filter) {
        if (filter.customersForDeletion === $scope.deletionMark.Include)
            delete filter.customersForDeletion;

        if (filter.contractsForDeletion === $scope.deletionMark.Include)
            delete filter.contractsForDeletion;
    }

    // Starting point
    //----------------

    $scope.deletionMark = Object.freeze({ Include: "0", Exclude: "1", Exclusive: "2" });
    let deletionMarkDefault = $scope.deletionMark.Include;
    Features.loading.then(async function () {
        deletionMarkDefault = $scope.features.Rtl ? $scope.deletionMark.Exclude : $scope.deletionMark.Include;
        $scope.filter.customersForDeletion = deletionMarkDefault;
        $scope.filter.contractsForDeletion = deletionMarkDefault;

        try {
            await fillCustomFieldsFilter('Customer', $scope.customFields, $scope.customFieldsTypes);
            await fillCustomFieldsFilter('Contract', $scope.customFields, $scope.customFieldsTypes);
            await fillCustomFieldsFilter('ComponentSubscription', $scope.componentSubscriptionCustomFields, $scope.componentSubscriptionCustomFieldsTypes);
            await fillCustomFieldsFilter('MeteredUsage', $scope.componentSubscriptionCustomFields, $scope.componentSubscriptionCustomFieldsTypes);
            await fillCustomFieldsFilter('DiscountSubscription', $scope.componentSubscriptionCustomFields, $scope.componentSubscriptionCustomFieldsTypes);

            // loading url query params into $scope and $scope.filter
            await loadQueryParameters();
            $scope.customFieldsSearchAvailable = true;
            // Load subscribers with updated params
            getSubscriptions();
        } catch (error) {
            console.error('An error occurred while processing filters:', error);
        }
    });

    // ReSharper disable JsUnreachableCode
    gettext("InProgress");
    gettext("PaymentPending");
    gettext("Aborted");
    gettext("Completed");
    gettext("Expired");

    gettext('CreditCard');
    gettext('BlackLabel');
    gettext('Debit');
    gettext('OnAccount');
    gettext('SwanOnAccount');

    gettext('Delete customer');
    gettext('Are you sure?');
    gettext('Hide customer');

    gettext('InvoicePayment');
    gettext('InTrial');
    gettext('Annulled');
    gettext('TrialExpired');
    gettext('TemporarilyInactive');
    gettext('InOrderProcess');
    gettext('WrittenOff');

    gettext('Confirmed');
    gettext('Unconfirmed');

    gettext('ArchiveOnly');
    gettext('Email');
    gettext('SnailMail');

    gettext('Receivable');
    gettext('Payment');
    gettext('Refund');
    gettext('Adjustment');
    gettext('Chargeback');
    gettext('Cancelation');

    gettext('Inactive');
    gettext('Normal');
    gettext('Trial');

    gettext('Created');
    gettext('InProgress');
    gettext('Prepared');
    gettext('PreliminarySucceeded');
    gettext('Succeeded');
    gettext('Undefined');
    gettext('Canceled');
    gettext('Chargeback');
    gettext('Pending');
    gettext('Failed');
    gettext('Unmapped');
    gettext('Refunded');
    gettext('ThreeDSecurePending');
    gettext('PartiallyRefunded');
    gettext('PartialChargeback');
    gettext('Finalizing');
    gettext('Scheduled');

    gettext('Bounce');
    gettext('Blocked');
    gettext('Spam');
    gettext('MRR');
    gettext('Billed Turnover');
    gettext('Active Contracts');
    gettext('Chargeable Contracts');

    gettext('Signup');
    gettext('Upgrade');

    gettext('ToBeSent');
    gettext('APIError');
    gettext("Without Payment Data");
    gettext("On Account");

    gettext("component");
    gettext("plan");
    gettext("plan variant");
    // ReSharper restore JsUnreachableCode
};
SubscriptionListController.$inject = ['$scope', '$http', '$location', 'gettextCatalog', 'gettext', 'ProductInfo',
    'Subscription', 'SubscriptionCounts', 'PaymentMethod', 'PaymentMethodNames', 'Customer', 'PaymentProviderSettings',
    'PUtill', 'DunningSettings', 'DocumentTemplate', 'SubscriptionReport', 'SalesEntities', 'Features',
    'DatepickerUtils', 'CustomFieldSettings'];
